(ns common.schema.entities.import-data)

(def schema
  [[:import-data/created-on-diff {:field/data-type          :data.type/long
                                  :field/default-visibility {:editor :editor.type/number
                                                             :grid   :editor.type/number
                                                             :filter :filter.type/number
                                                             :field-visibility :in-use}
                                  :field/default-authorization      {:access/read  :role/guest-buy-side
                                                             :access/write :role/guest-buy-side}
                                  :field/translations       {:en "Created on"}
                                  }]
   [:import-data/passed-on-diff {:field/data-type          :data.type/long
                                 :field/default-visibility {:editor :editor.type/number
                                                            :grid   :editor.type/number
                                                            :filter :filter.type/number
                                                            :field-visibility :in-use}
                                 :field/default-authorization      {:access/read  :role/guest-buy-side
                                                            :access/write :role/guest-buy-side}
                                 :field/translations       {:en "Deal, Pass date"}
                                 }]
   [:import-data/put-on-hold-on-diff {:field/data-type          :data.type/long
                                      :field/default-visibility {:editor :editor.type/number
                                                                 :grid   :editor.type/number
                                                                 :filter :filter.type/number
                                                                 :field-visibility :in-use}
                                      :field/default-authorization      {:access/read  :role/guest-buy-side
                                                                 :access/write :role/guest-buy-side}
                                      :field/translations       {:en "Deal, hold date"}
                                      }]
   [:import-data/on-hold-until-diff {:field/data-type          :data.type/long
                                     :field/default-visibility {:editor :editor.type/number
                                                                :grid   :editor.type/number
                                                                :filter :filter.type/number
                                                                :field-visibility :in-use}
                                     :field/default-authorization      {:access/read  :role/guest-buy-side
                                                                :access/write :role/guest-buy-side}
                                     :field/translations       {:en "Deal, on hold until"}
                                     }]
   [:import-data/owner {:field/data-type          :data.type/text-simple
                        :field/default-visibility {:editor :editor.type/select
                                                   :grid   :editor.type/select
                                                   :filter :filter.type/select
                                                   :field-visibility :in-use}
                        :field/default-authorization      {:access/read  :role/guest-buy-side
                                                   :access/write :role/guest-buy-side}
                        :field/translations       {:en "Deal, owner"}
                        }]])
